var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.tooltipText,"size":"sm","variant":"neutral"}},[_vm._v("\n  "+_vm._s(_vm.__('protected'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }